const ONES = [
    "", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه",
    "ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"
];

const TENS = ["", "", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
const HUNDREDS = ["", "صد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
const SCALES = ["", "هزار", "میلیون", "میلیارد", "تریلیون"];

export const toEnglishDigits = (value) => {
    if (value === null || value === undefined) return value;

    return String(value)
        .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 1776))
        .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 1632));
};

const threeDigitsToPersianWords = (value) => {
    const parts = [];
    const hundreds = Math.floor(value / 100);
    const remainder = value % 100;

    if (hundreds) parts.push(HUNDREDS[hundreds]);

    if (remainder < 20) {
        if (remainder) parts.push(ONES[remainder]);
    } else {
        parts.push(TENS[Math.floor(remainder / 10)]);
        if (remainder % 10) parts.push(ONES[remainder % 10]);
    }

    return parts.join(" و ");
};

export const numberToPersianWords = (value) => {
    const normalizedValue = toEnglishDigits(value);
    const plainValue = normalizedValue === null || normalizedValue === undefined
        ? ""
        : normalizedValue.replace(/[,٬]/g, "").trim();

    if (!/^\d+$/.test(plainValue)) return "";

    const numericValue = Number(plainValue);
    if (!Number.isSafeInteger(numericValue) || numericValue < 0) return "";
    if (numericValue === 0) return "صفر";

    const parts = [];
    let remainingValue = numericValue;
    let scaleIndex = 0;

    while (remainingValue > 0 && scaleIndex < SCALES.length) {
        const group = remainingValue % 1000;
        if (group) {
            const groupWords = threeDigitsToPersianWords(group);
            parts.unshift(SCALES[scaleIndex] ? `${groupWords} ${SCALES[scaleIndex]}` : groupWords);
        }
        remainingValue = Math.floor(remainingValue / 1000);
        scaleIndex += 1;
    }

    return remainingValue === 0 ? parts.join(" و ") : "";
};
